module.exports = __webpack_public_path__ + "img/SAC.1f2803a0.png";